export default __webpack_public_path__ + "static/media/profile.fd3117fd.svg";